export default "__VITE_ASSET__COSqsZ3C__"